module.exports = __webpack_public_path__ + "static/media/fabio_jose_santos_de_oliveira.7695dd8b.jpg";